import { ref, onMounted, onUnmounted } from 'vue';

export function useIsMobile() {
    const isMobile = ref(false);

    const checkMobile = () => {
        const ua = navigator.userAgent;
        isMobile.value =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) ||
            (navigator.maxTouchPoints > 0 && window.innerWidth <= 1024);

        console.log(navigator.maxTouchPoints > 0 && window.innerWidth <= 1024)
    };

    onMounted(() => {
        checkMobile();
        window.addEventListener('resize', checkMobile);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', checkMobile);
    });

    return { isMobile };
}